import { features } from '@/mocks/homeContent';

const featureImages: Record<string, string> = {
  "feat-save-money-img": "https://readdy.ai/api/search-image?query=A%20stack%20of%20neatly%20folded%20fashion%20clothing%20items%20with%20visible%20price%20tags%20hanging%20from%20each%20piece%20placed%20on%20a%20warm%20wooden%20surface%20next%20to%20a%20calculator%20showing%20savings%20numbers%20bright%20natural%20lighting%20communicating%20value%20and%20affordability%20lifestyle%20photography%20with%20cozy%20atmosphere&width=600&height=420&seq=feat-save-money-v2&orientation=landscape",
  "feat-trusted-links-img": "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smartphone%20screen%20showing%20a%20verified%20badge%20icon%20next%20to%20product%20listings%20on%20a%20shopping%20interface%20with%20green%20checkmarks%20and%20trust%20indicators%20on%20a%20clean%20desk%20with%20soft%20bokeh%20background%20warm%20ambient%20light%20conveying%20reliability%20and%20safety&width=600&height=420&seq=feat-trusted-links-v2&orientation=landscape",
  "feat-easy-shopping-img": "https://readdy.ai/api/search-image?query=Organized%20fashion%20items%20neatly%20arranged%20in%20labeled%20boxes%20on%20open%20shelving%20with%20a%20tablet%20showing%20a%20digital%20catalog%20interface%20warm%20natural%20lighting%20minimalist%20retail%20organization%20concept%20clean%20aesthetic%20with%20soft%20earthy%20tones&width=600&height=420&seq=feat-easy-shopping-v2&orientation=landscape",
};

export default function FeatureGrid() {
  return (
    <section id="features" className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-14 md:mb-16">
          <p className="text-xs tracking-[0.2em] uppercase text-foreground-500 font-medium mb-3">
            Why Choose Us
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Why Use Superbuy Spreadsheet
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Thousands of international buyers trust our curated spreadsheet for quality finds and reliable shopping
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 group flex flex-col"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={featureImages[feature.imageSeq]}
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-7">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}